import styled from "styled-components";

const P = styled.p`
  text-indent: 25px;
  text-align: justify;
`;

export default P;
